<template>
  <div :class="$style.message">
    <UserThumbnail
      :personalityType="personalityType"
      :class="$style.message__icon"
    />
    <LoadingIndicator :class="$style.message__wave" />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import UserThumbnail from '@/components/atoms/UserThumbnail.vue'
import LoadingIndicator from '@/components/atoms/LoadingIndicator.vue'
import type { PersonalityType } from '@/types/app'

export default defineComponent({
  name: 'ChatMessageUserTypingIndicator',
  components: {
    UserThumbnail,
    LoadingIndicator,
  },
  props: {
    personalityType: {
      type: String as PropType<PersonalityType>,
      default: 'A',
    },
  },
})
</script>

<style lang="scss" module>
.message {
  display: flex;
  align-items: center;

  &__icon {
    $size: 44px;

    width: $size;
    height: $size;
  }

  &__wave {
    flex: 1 1 0%;

    &:nth-child(n + 2) {
      margin-left: 24px;
    }
  }
}
</style>
